import React from 'react'

const EchannelReporting = ({ data, echannels, pageJson, translations, countryList, getCountryTaxonomy }) => {
  let _eChannels = echannels !== undefined && echannels !== '' ? echannels.length > 0 ? echannels.filter(item => item.id === data.cashConcentration.reportedEChannelId)[0] : [] : [];
  return (
    <div className="ie-detail-container">
      <div className="ie-detail-container__heading">{`3. ${translations(pageJson.eChannelRep)}`}</div>
      <div className="ie-detail-container__content">
        <p>{translations(pageJson.eChannelHSBCnetInfo1)}</p>
        <p>{translations(pageJson.eChannelHSBCnetInfo2)}</p>
        <dl className="ie-detail-section__content__list">
          {/* <dt>{translations(pageJson.title)}</dt> */}
          {/* <dd>{data.cashConcentration.eChannelReported !== undefined && data.cashConcentration.eChannelReported === true ? 'Yes' : 'No'}</dd> */}
          {
            data.cashConcentration.eChannelReported === false
              ? <React.Fragment>
                <dt>{translations(pageJson.eChannel)}</dt>
                <dd>
                  <b>
                    {_eChannels !== undefined && _eChannels.eChannelType !== undefined ? _eChannels.eChannelType.name : ''}, {_eChannels !== undefined && _eChannels.country !== undefined ?
                      countryList !== undefined
                        ? getCountryTaxonomy(_eChannels).country.name : _eChannels.country.name : ''}
                  </b>
                  <p>{_eChannels !== undefined && _eChannels.profileOwner !== undefined ? _eChannels.profileOwner.name : ''}</p>
                </dd>
              </React.Fragment>
              : null
          }
          <dd>
            <span style={{ marginRight: "1rem" }}>{translations(pageJson.title)}</span>
            <span><i className={`icon ${data.cashConcentration.eChannelReported ? 'icon-ballot-box-with-check' : 'icon-ballot-box'} gdocs-valign-middle hintText-icon`}></i></span>
          </dd>
        </dl>
      </div>
    </div>
  )
}

export default EchannelReporting;



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/CCPreview/EchannelReporting.js